import { render, staticRenderFns } from "./itemTitle.vue?vue&type=template&id=d09f9c52&scoped=true&"
import script from "./itemTitle.vue?vue&type=script&lang=js&"
export * from "./itemTitle.vue?vue&type=script&lang=js&"
import style0 from "./itemTitle.vue?vue&type=style&index=0&id=d09f9c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09f9c52",
  null
  
)

export default component.exports